module.exports = __webpack_public_path__ + "media/images/icon-text-white-980a19cc.svg";